import React from "react";
import { useSelector } from "react-redux";
import { Grid } from "semantic-ui-react";
import DropDown from "@commonComponents/formComponents/CustomDropDown";
import { selectDeclarationList, selectDeclarationTypeList } from "../selectors";
import { useCurrentShipmentType } from "@hooks/useCurrentShipmentType";


export const HeaderForm = React.memo(({ onSelect, transmissionList, jobWheels, dataSource: { declaration, declType, transmissionType }, renderAtFirst, renderAtLast, renderActionBtns, disableFields = {} }) => {
  const {countryCode} = useCurrentShipmentType()
  const EntryState = jobWheels?.["ES_ENTRY_JOB_WHEEL"]?.value?.state || ""
  const CustomState = jobWheels?.["ES_CUSTOM_JOB_WHEEL"]?.value?.state || ""
  const declarationList = useSelector(selectDeclarationList)
  const declarationTypeList = useSelector(selectDeclarationTypeList)
  const shipmentInProcess = ["STATE_ENTRY_NONE", "STATE_ENTRY_IN_PROCESS", "STATE_ENTRY_READY"].includes(EntryState);
  const typeBAccepted = ['STATE_TYPE_B_ACCEPTED'].includes(CustomState)
  const entryAccepted = ("STATE_ENTRY_ACCEPTED" === EntryState)
  const transmissionTypeEnabled = ["STATE_ENTRY_NONE", "STATE_ENTRY_IN_PROCESS", "STATE_ENTRY_READY", 
  "STATE_ENTRY_ACCEPTED", "STATE_ENTRY_RFI_ACCEPTED", "STATE_ENTRY_RELEASED", "STATE_ENTRY_AMEND_ACCEPTED", 
  "STATE_ENTRY_AMEND_REJECTED","STATE_ENTRY_EXT_IN_PROCESS",
  "STATE_ENTRY_EXT_READY"].includes(EntryState) 
  || (['NL']?.includes(countryCode)&&["STATE_ENTRY_FILED","STATE_ENTRY_CONTROL"]?.includes(EntryState))

  return (
    <Grid className='responsiveGridCss'>
      <div className='formContainer'>
        <Grid.Row>
          {renderAtFirst && renderAtFirst({ onSelect })}
          <Grid.Column>
            <DropDown
              id='declaration'
              name='declaration'
              label={'DECLARATION'}
              labelClass='text-none'
              isDisabled={!shipmentInProcess || window.typeOfUser === 'BROKER_KN_ADMIN' || transmissionType === 'NOT'}
              data={declarationList}
              value={declaration}
              text={declaration}
              boxNumber='1/1'
              onChange={onSelect}
            />
          </Grid.Column>
          <Grid.Column>
            {/* {console.log("DECL typeBAccepted__",typeBAccepted,
            "entryAccepted__", entryAccepted,
            "disableFields?.declaration__", disableFields?.declaration, 
            "!shipmentInProcess",!shipmentInProcess, 
            "window.typeOfUser",window.typeOfUser)} */}
            <DropDown
              id='declType'
              name='declType'
              boxNumber='1/2'
              label={'DEC_TYPE'}
              direction='left'
              data={declarationTypeList}
              isDisabled={
                typeBAccepted && entryAccepted
                  ? false
                  : disableFields?.declaration ||
                    !shipmentInProcess ||
                    window.typeOfUser === 'BROKER_KN_ADMIN' || transmissionType === 'NOT'
              }
              value={declType}
              text={declType}
              onChange={onSelect}
            />
          </Grid.Column>
          <Grid.Column>
            <DropDown
              id='transmissionType'
              name='transmissionType'
              label={'TRANSMISSION_TYPE'}
              data={transmissionList}
              isDisabled={!transmissionTypeEnabled || window.typeOfUser === 'BROKER_KN_ADMIN' || transmissionType === 'NOT' }
              value={transmissionType}
              text={transmissionType}
              onChange={onSelect}
            />
          </Grid.Column>
          {renderAtLast && renderAtLast({ onSelect })}
        </Grid.Row>
        <div className='actionbtns'>{renderActionBtns && renderActionBtns()}</div>
      </div>
    </Grid>
  )
})